"use client";

import { useMemo, useSyncExternalStore } from "react";
import { PROV_LAGE_EVENT, senasteProvLage, type ProvLageDetalj } from "@/lib/prov/prov-lage-signal";

// Used by Nav while an elev is on /prov-elev/[passId] to know the one fact that isn't derivable
// from the URL: is the elev inside an ACTIVE pass right now, and does that pass allow
// mobilparning. The header is the same as everywhere else (Erik 2026-09-15); the only
// difference is that the mobile-pairing button answers with a "förbjudet"-popup when the pass
// forbids it. On the resultat page there is no active pass → normal.
//
// No poll of its own (prestandapass 2026-10-27): ProvVakt already polls /api/prov-elev/aktivt
// every 6 s on prov pages and announces each answer (prov-lage-signal.ts); this listens.

export interface ProvNavLage {
  /** Eleven är inne i ett aktivt (startat) pass just nu. */
  aktivt: boolean;
  /** Passet tillåter mobilparning (bara meningsfullt när aktivt). */
  mobilTillaten: boolean;
}

const NORMAL: ProvNavLage = { aktivt: false, mobilTillaten: true };

function franDetalj(d: ProvLageDetalj | null): ProvNavLage {
  return d ? { aktivt: d.aktivt, mobilTillaten: d.mobilTillaten } : NORMAL;
}

function prenumerera(onAndring: () => void): () => void {
  window.addEventListener(PROV_LAGE_EVENT, onAndring);
  return () => window.removeEventListener(PROV_LAGE_EVENT, onAndring);
}

/** The server never knows ProvVakt's last answer: render normal there and hydrate the same. */
const ingetPaServern = () => null;

export function useProvNavMobilparning(enabled: boolean): ProvNavLage {
  // senasteProvLage() keeps one object per answer, so the snapshot is stable between answers.
  const detalj = useSyncExternalStore(prenumerera, senasteProvLage, ingetPaServern);
  return useMemo(() => (enabled ? franDetalj(detalj) : NORMAL), [enabled, detalj]);
}
